import { createUseStyles } from "react-jss";
import { alpha } from "../../theme/Mixins";

const MOBILE_DIMENSIONS = 293;
const DESKTOP_DIMENSIONS = 460;
const CROP_CONTENT_DESKTOP_SQUARE_SIZE = 372;
const CROP_CONTENT_STATEMENT_HEIGHT = 71;
const RESIZE_CAROUSEL = "resize-carousel";
const CROP_CONTENT = "crop-content";

export default createUseStyles({
    container: {
        position: "relative",
        width: ({ isMobileView }) => (isMobileView ? "100%" : "auto"),
    },
    statementsContainer: {
        width: ({ isMobileView, theme }) => {
            let calWidth = isMobileView ? "100%" : "auto";
            if (theme.ContentResponsivenessOption === CROP_CONTENT && isMobileView) {
                calWidth = `${MOBILE_DIMENSIONS}px`;
            }
            return calWidth;
        },
        display: "flex",
        overflowX: "hidden",
        scrollBehavior: "smooth",
        margin: "0 auto",
        justifyContent: "center",
    },
    statement: {
        width: ({ isMobileView, theme }) => {
            let calWidth = isMobileView ? `${MOBILE_DIMENSIONS}px` : `${DESKTOP_DIMENSIONS}px`;
            if (theme.ContentResponsivenessOption === CROP_CONTENT && !isMobileView) {
                // Crop content desktop
                calWidth = `${CROP_CONTENT_DESKTOP_SQUARE_SIZE}px`;
            }

            return calWidth;
        },
        height: ({ isMobileView, theme }) => {
            let calHeight = `${DESKTOP_DIMENSIONS}px`;
            if (theme.ContentResponsivenessOption === CROP_CONTENT && !isMobileView) {
                // Crop content desktop
                calHeight = `${CROP_CONTENT_DESKTOP_SQUARE_SIZE}px`;
            } else if (isMobileView && theme.ContentResponsivenessOption !== RESIZE_CAROUSEL) {
                // Crop content and others mobile
                calHeight = `${MOBILE_DIMENSIONS}px`;
            } else if (theme.ContentResponsivenessOption === RESIZE_CAROUSEL) {
                calHeight = "auto";
            }
            return calHeight;
        },
        backgroundColor: ({ color }) => color,
        color: "#555555",
        textAlign: "center",
        minWidth: ({ isMobileView }) => (isMobileView ? "100%" : ""),
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: ({ justifyContent }) => justifyContent,
        background: ({ theme, color }) =>
            `${
                theme.ShowStatementBackgroundSettings
                    ? alpha(color ?? theme.ControlBackground, theme.StatementBackgroundAlpha)
                    : alpha(theme.ControlBackground, 0)
            }`,
        borderRadius: ({ theme, isMobileView }) => {
            let calDimension = 0;
            if (isMobileView) {
                calDimension = MOBILE_DIMENSIONS;
            } else if (theme.ContentResponsivenessOption === CROP_CONTENT) {
                calDimension = CROP_CONTENT_DESKTOP_SQUARE_SIZE;
            } else {
                calDimension = DESKTOP_DIMENSIONS;
            }

            return `${
                theme.ShowStatementBackgroundSettings
                    ? Math.min(
                          theme.CustomBorderValue
                              ? theme.StatementBorderRadius
                              : theme.ChoiceListBackgroundBorderRadius,
                          calDimension / 2,
                      )
                    : ""
            }px`;
        },
        "& .statementTextContent": {
            padding: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: "1.2",
        },

        "& .statementTextContent:empty": {
            display: "none",
        },

        "& .image-wrapper": {
            display: "flex",
            justifyContent: "center",
            width: ({ isMobileView }) => (isMobileView ? "100%" : "auto"),
            height: ({ theme, isMobileView }) => {
                let calHeight =
                    theme.ContentResponsivenessOption === RESIZE_CAROUSEL ? "auto" : "100%";
                if (theme.ContentResponsivenessOption === CROP_CONTENT && !isMobileView) {
                    calHeight = "80%";
                }
                return calHeight;
            },

            flex: 1,

            "& .image-element": {
                borderRadius: ({ theme }) => {
                    if (!theme.ShowStatementBackgroundSettings || !theme.CustomBorderValue) {
                        if (theme.ChoiceListBackgroundBorderRadius === 100) return "20px";
                        if (theme.ChoiceListBackgroundBorderRadius === 15) return "8px";
                    }

                    if (
                        theme.ShowStatementBackgroundSettings &&
                        theme.StatementBackgroundAlpha === 0
                    ) {
                        return `${theme.StatementBorderRadius}px`;
                    }
                    return "";
                },
            },
        },

        "& .crop-image": {
            width: ({ isMobileView }) => {
                return isMobileView
                    ? `${MOBILE_DIMENSIONS}px`
                    : `${CROP_CONTENT_DESKTOP_SQUARE_SIZE}px`;
            },
            height: ({ isMobileView }) => {
                return isMobileView
                    ? "235px"
                    : `${CROP_CONTENT_DESKTOP_SQUARE_SIZE - CROP_CONTENT_STATEMENT_HEIGHT}px`;
            },
            objectFit: "cover",
            objectPosition: "center center",
        },

        "& .cropContentImageOnly": {
            height: ({ isMobileView }) =>
                isMobileView ? `${MOBILE_DIMENSIONS}px` : `${CROP_CONTENT_DESKTOP_SQUARE_SIZE}px`,
        },

        "& .fade-in-element": { animation: "mbsc-anim-f-in 2s" },
    },
    navigationButtonsPanel: {
        textAlign: "center",
        display: "flex",
        justifyContent: ({ justifyContent }) => justifyContent,
        marginTop: "25px",

        "& .fixedWidth": {
            flex: "0 0 20px",
            minWidth: "20px",
            display: "flex",
            alignItems: "center",
        },
    },
    navigationButton: {
        height: "100%",
        cursor: "pointer",
    },
});
